import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./styles.css";

const legacyRoutes = {
  panel: "/",
  ogrenciler: "/ogrenciler",
  kartlar: "/kartlar",
  cihazlar: "/cihazlar",
  raporlar: "/raporlar",
  loglar: "/loglar",
  okullar: "/okullar",
  ayarlar: "/ayarlar",
};
const legacyHash = window.location.hash.replace(/^#\/?/, "").split("?")[0];
if (legacyRoutes[legacyHash])
  window.history.replaceState(null, "", legacyRoutes[legacyHash]);

createApp(App).use(createPinia()).use(router).mount("#app");
